import React from 'react';
import '../styles/tokens.css';
import '../styles/Chip.css';

export const Chip = ({
    label,
    icon,
    selected = false,
    showCross = false,
    onClick,
    className = '',
    ...props
}) => {
    const classes = [
        'ds-chip',
        selected ? 'ds-chip-selected' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <button 
            type="button" 
            className={classes} 
            onClick={onClick}
            aria-pressed={selected}
            {...props}
        >
            {icon && <span className="ds-chip-icon">{icon}</span>}
            <span className="ds-chip-label">{label}</span>
            {selected && showCross && (
                <span className="ml-[var(--ds-space-2)] flex items-center justify-center opacity-80 hover:opacity-100 transition-opacity">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                </span>
            )}
        </button>
    );
};
